import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
const keyPrefix = 'delete_role';
export const useDeleteRoleTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    delete: 'Удалить роль',
    toast_success: 'Роль успешно удалена',
    toast_error: 'Не удалось удалить роль',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    delete: 'Delete role',
    toast_success: 'Role deleted successfully',
    toast_error: 'Failed to delete role',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    delete: 'Eliminar rol',
    toast_success: 'Rol eliminado con éxito',
    toast_error: 'Error al eliminar el rol',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    delete: 'Excluir função',
    toast_success: 'Função excluída com sucesso',
    toast_error: 'Falha ao excluir a função',
  },
}) : {}) as Record<string, unknown>;
